import "./ImageZoom.css";

const ImageZoom = ({ src, alt, width, height }) => {
  return (
    <div
      className="image-zoom-container"
      style={{ width: width, height: height }}
    >
      <img src={src} alt={alt} className="image-zoom-img" />
    </div>
  );
};

export default ImageZoom;
